import React, { Component, cloneElement, useState } from "react";
import {
  List,
  ExportButton,
  CreateButton,
  SelectInput,
  RefreshButton,
  TopToolbar,
  Datagrid,
  TextField,
  ReferenceInput,
  AutocompleteInput,
  ReferenceField,
  DateField,
  ShowButton,
  Filter,
  TextInput,
  GET_ONE,
  BooleanField,
  useResourceContext,
  useRecordContext,
  required,
} from "react-admin";
import { Scrollbars } from "react-custom-scrollbars";
import Spinner from "../../src/spinner";
import myDataProvider from "../myRestProvider";
import { RUN_TIME_API_ENDPOINT, CommonHeaderOption } from "../common/common";
import { unparse as convertToCSV } from "papaparse/papaparse.min";
import Modal from "react-responsive-modal";
import Swal from "sweetalert2";
import { useLocation } from 'react-router-dom';

const ShipTosFilter = (props) => (
  <Filter {...props}>
    <TextInput source="scheme_name" />
    <TextInput source="no_of_coupons" />
    <TextInput source="coupon_code" />
    <SelectInput
      source="discount_type"
      choices={[
        { id: "%", name: "%" },
        { id: "Amount", name: "Amount" },
      ]}
    />
    <SelectInput
      validate={required()} 
      source="discount_scheme_type"
      choices={[
        { id: "static", name: "Static" },
        { id: "dynamic", name: "Dynamic" },
      ]}
    />
    {/* <TextInput source='total_used_voucher' />
        <TextInput source='total_assigned_voucher' />
        <TextInput source='total_unused_voucher' />
        <TextInput source='total_unassigned_voucher' /> */}
    <SelectInput
      source="is_finalized"
      choices={[
        { id: true, name: "True" },
        { id: false, name: "False" },
      ]}
    />
  </Filter>
);

const ListActions = (props) => {
  const location = useLocation();
  const resource = useResourceContext();
  const [modalShow, setModalShow] = useState(false);
  const [modalMsg, setModalMsg] = useState("");
  const [customFilterUrl, setCustomFilterUrl] = useState(
    location.search
  );

  const callExport = (e) => {
    const options = CommonHeaderOption();
    const apiUrl = RUN_TIME_API_ENDPOINT;
    e.preventDefault();
    console.log("...", window.location.href, `${apiUrl}/${resource}_csv`);
    options.method = "GET";
    let _url = window.location.href.split("?");
    if (_url.length > 1 && _url[1] !== "") {
      console.log("params found");

      setCustomFilterUrl(_url[1], () => {
        fetch(`${apiUrl}/${resource}_csv?${customFilterUrl}`, options)
          .then((res) => {
            return res.json();
          })
          .then((jsonD) => {
            console.log("json= inside callback", jsonD.data);
            const msg = jsonD.data ? jsonD.data[0].message : "";
            Swal.fire({
              html: msg,
              icon: "success",
            });
            //   this.setState({ modalShow: true});
            //   this.setState({ modalMsg: msg});
          });
      });
    } else {
      setCustomFilterUrl(
        location.search
      );
      fetch(
        `${apiUrl}/${
          resource
        }_csv?${location.search}`,
        options
      )
        .then((res) => {
          return res.json();
        })
        .then((jsonD) => {
          console.log("json= inside callback", jsonD.data);
          const msg = jsonD.data ? jsonD.data[0].message : "";
          Swal.fire({
            html: msg,
            icon: "success",
          });
          // this.setState({ modalShow: true});
          // this.setState({ modalMsg: msg});
        });
    }
  };
  // exporterModal = () => {
  //   return "";
  // };

  const onClose = () => {
    setModalShow(false);
  };

  const {
    filterValues,
    total,
    maxResults,
    currentSort,
    exporter,
    permanentFilter,
    showFilter,
    displayedFilters,
    filters,
    basePath,
  } = props;
  const csvResource = resource + "_csv";

  return (
    <React.Fragment>
      <TopToolbar>
        {filters &&
          cloneElement(filters, {
            resource,
            showFilter,
            displayedFilters,
            filterValues,
            context: "button",
          })}
        <RefreshButton />
        {/* <ExportButton
          onClick={(e) => this.callExport(e)}
          disabled={total === 0}
          resource={csvResource}
          sort={currentSort}
          filter={{ ...filterValues, ...permanentFilter }}
          exporter={this.exporterModal}
          maxResults={maxResults}
          /> */}
        <CreateButton basePath={basePath} />
        {/* <div>
          <button
            className="export-button"
            onClick={(e) => callExport(e)}
            disabled={total === 0}
            sort={currentSort}
            filter={{ ...filterValues, ...permanentFilter }}
          >
            {<GetAppIcon />}
            <span>{'export'}</span>
          </button>
        </div> */}
      </TopToolbar>
      {modalShow && (
        <Modal open={modalShow} onClose={onClose} center>
          <h3>{modalMsg}</h3>
        </Modal>
      )}
    </React.Fragment>
  );
};

const ShowNoCoupon = ({ source }) => {
  const record = useRecordContext();
  return (
    <span>{record.no_of_coupons === null ? "-" : record.no_of_coupons}</span>
  );
};

const ShowCouponCode = ({ source }) => {
  const record = useRecordContext();
  return (
    <span>{record.coupon_code === null ? "-" : record.coupon_code}</span>
  );
};

const DiscountSchemesList = (props) => {
  // const { state, props, permissions } = this;
  return (
    <React.Fragment>
      <Scrollbars class="scroll-container">
        <List
          {...props}
          sort={{ field: "created_at", order: "DESC" }}
          filters={<ShipTosFilter />}
          title="Coupon Scheme Detail"
          bulkActionButtons={false}
          actions={<ListActions permissions={props} />}
        >
          <Datagrid rowClick="show" bulkActionButtons={false}>
            <TextField source="scheme_name" />
            <TextField source="is_finalized" />
            <TextField source="discount_scheme_type" allowEmpty />
            <ShowNoCoupon source="no_of_coupons" />
            <ShowCouponCode source="coupon_code" />
            <TextField source="discount_type" />
            <TextField source="discount_value" />
            <DateField showTime source="start_datetime" allowEmpty />
            <DateField showTime source="end_datetime" allowEmpty />
            <TextField source="total_used_voucher" />
            <TextField source="total_assigned_voucher" />
            <TextField source="total_unused_voucher" />
            <TextField source="total_unassigned_voucher" />
            <ShowButton />
          </Datagrid>
        </List>
      </Scrollbars>
      {/* {
                    state.moodalShow &&
                    <Modal open={state.moodalShow} onClose={this.onClose} center>
                        <h3>{state.modalMsg}</h3>
                    </Modal>
                } */}
    </React.Fragment>
  );
};

export default DiscountSchemesList;
